import { MInput, MSelect } from "components/forms";
import {
  BoxDanger,
  ErrorNotification,
  MnemoLoading,
  Title,
} from "components/misc";
import { MTable } from "components/table";
import { REVISOR_CONTEXTS } from "const";
import { Button, Container, Section } from "design-react-kit";
import { adminService, networkErrorHelper } from "libs";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";

class ViewerUDA extends Component {
  PAYLOAD_CONTEXTS = {
    options: [
      { label: "SELEZIONARE", value: "" },
      { label: "Ex art.13", value: REVISOR_CONTEXTS.ART13 },
      { label: "Abilitazioni 30", value: REVISOR_CONTEXTS.ABILITAZIONE30 },
      { label: "Abilitazioni 60", value: REVISOR_CONTEXTS.ABILITAZIONE60 },
      { label: "TFA Indire", value: REVISOR_CONTEXTS.TFAINDIRE },
    ],
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      payload: [],
      rndKey: 0,
      whereObj: {
        keySearch: null,
        aaYear: "2024", //process.env.REACT_APP_AA_YEAR,
        limit: 200,
        contextFilter: null,
      },
      searchFilter: {
        searchFilter: {},
      },
      searchFields: [
        {
          id: "finder",
          field: "finder",
          name: "finder",
          label: "Cerca per data esame",
          type: "date",
          className: "form-control",
          value: "",
        },
        {
          id: "aaYear",
          field: "aaYear",
          name: "aaYear",
          label: "Anno Accademico",
          type: "text",
          className: "form-control",
          value: "",
        },
      ],
      contextSelectField: {
        id: "context-filter",
        field: "context-filter",
        name: "context-filter",
        label: "Seleziona contesto esame",
        payload: this.PAYLOAD_CONTEXTS,
        onChange: (name, value) => {
          this.onChangeContext(value);
        },
      },
      searched: false,
    };
  }

  //--- ---

  // Helper per ottenere i valori dei campi di ricerca
  getFieldValues = () => {
    return this.state.searchFields.reduce((acc, field) => {
      acc[field.id] = field.value;
      return acc;
    }, {});
  };

  // Gestore unificato per i cambi dei campi di ricerca
  handleFieldChange = (fieldId, value) => {
    this.setState((prevState) => ({
      searchFields: prevState.searchFields.map((field) =>
        field.id === fieldId ? { ...field, value: value || "" } : field,
      ),
      whereObj: {
        ...prevState.whereObj,
        [fieldId]: value || null,
      },
    }));
  };

  // Gestore centralizzato della ricerca
  handleSearch = () => {
    const { finder, aaYear } = this.getFieldValues();

    // Validazione contesto obbligatorio
    if (this.state.whereObj.contextFilter === null) {
      ErrorNotification.render(
        "Selezionare un contesto prima di effettuare la ricerca.",
        "errore",
      );
      return false;
    }

    // Validazione anno accademico obbligatorio
    if (!aaYear || aaYear.trim() === "") {
      ErrorNotification.render(
        "Inserire l'anno accademico prima di effettuare la ricerca.",
        "errore",
      );
      return false;
    }

    // Validazione lunghezza minima per la ricerca
    if (finder.length < 3 || finder === "") {
      this.setState({
        loading: false,
        payload: [],
        rndKey: Math.floor(Math.random() * 1000 + 1),
      });
      return false;
    }

    const whereObj = {
      ...this.state.whereObj,
      keySearch: finder,
      aaYear: aaYear || null,
    };

    this.loadRemote(whereObj);
  };

  tableConfig = {
    columns: [
      {
        id: "id",
        Header: "Column 0",
        isVisible: false,
        accessor: "id",
      },
      {
        id: "fullName",
        Header: "Nome e Cognome",
        accessor: "fullName",
      },
      {
        id: "email",
        Header: "Email",
        accessor: "email",
      },
      {
        id: "mobile",
        Header: "Telefono",
        accessor: "mobile",
      },
      {
        id: "registrationCode",
        Header: "Codice Registrazione",
        accessor: "registrationCode",
      },
      {
        id: "courseCode",
        Header: "Codice Corso",
        accessor: "courseCode",
      },
      {
        id: "status",
        Header: "Stato UDA",
        accessor: "status",
      },
      {
        id: "competitionClass",
        Header: "Classe di Conc.",
        accessor: "competitionClass",
      },
      {
        id: "revisionerFullName",
        Header: "Revisore",
        accessor: "revisionerFullName",
      },
      {
        id: "context",
        Header: "Contesto",
        accessor: "context",
      },
    ],
    /*actions: [
      {
        id: "detail",
        accessor: "id",
        label: "Abilita/Disabilita Modifica",
        icon: "it-file",
        className: "MTable-actions",
        onClick: (e, value) => {
          this.props.toggleEditing({ id: value });
        },
      },
    ],*/
  };

  tableConfig_TFAIndire = {
    columns: [
      {
        id: "id",
        Header: "Column 0",
        isVisible: false,
        accessor: "id",
      },
      {
        id: "fullName",
        Header: "Nome e Cognome",
        accessor: "fullName",
      },
      {
        id: "email",
        Header: "Email",
        accessor: "email",
      },
      {
        id: "mobile",
        Header: "Telefono",
        accessor: "mobile",
      },
      {
        id: "registrationCode",
        Header: "Codice Registrazione",
        accessor: "registrationCode",
      },
      {
        id: "courseCode",
        Header: "Codice Corso",
        accessor: "courseCode",
      },
      {
        id: "status",
        Header: "Stato UDA",
        accessor: "status",
      },
      {
        id: "revisionerFullName",
        Header: "Revisore",
        accessor: "revisionerFullName",
      },
      {
        id: "context",
        Header: "Contesto",
        accessor: "context",
      },
    ],
  };

  onChangeContext = (value) => {
    const isDefault = value === "" || value === null;

    this.setState((prevState) => ({
      contextSelectField: { ...prevState.contextSelectField, value: value },
      whereObj: {
        ...prevState.whereObj,
        contextFilter: isDefault ? null : value,
      },
    }));
  };

  loadRemote(whereObj) {
    this.setState({ loading: true, searched: true });

    adminService
      .getUDAByExamDate(whereObj)
      .then(({ data }) => {
        //--- start: prepare reactTable ---
        const items = [];
        Object.entries(data.payload.result).forEach(([key, val]) => {
          //--- manage exception to render human-readable data ---
          if (val.status === null) {
            val.status = "--- ---";
          }
          /*if (val.enabled) {
            val.tmpEnabled = "abilitato";
          } else {
            val.tmpEnabled = "disabilitato";
          }*/

          items.push(val);
        });

        this.setState({
          loading: false,
          payload:
            Object.entries(data.payload.result).length === 0 ? [] : items,
          rndKey: Math.floor(Math.random() * 1000 + 1),
        });
        //--- end: prepare reactTable ---
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false });
        if (!networkErrorHelper.is404(error)) {
          this.setState({
            loading: false,
            payload: [],
            rndKey: Math.floor(Math.random() * 1000 + 1),
          });

          networkErrorHelper.notify(error);
        } else {
          this.setState({
            loading: false,
            payload: [],
            rndKey: Math.floor(Math.random() * 1000 + 1),
          });
        }
      });
  }

  onDownload = () => {
    const array = this.state.payload;

    let str =
      "Nome e Cognome;Email;Telefono;Codice Registrazione; Codice Corso; Stato UDA; Classe di Concorso; Revisore; Contesto;\r\n";

    const keys = [
      "fullName",
      "email",
      "mobile",
      "registrationCode",
      "courseCode",
      "status",
      "competitionClass",
      "revisionerFullName",
      "context",
    ];

    for (let i = 0; i < array.length; i++) {
      let line = "";

      for (let j = 0; j < keys.length; j++) {
        const key = keys[j];

        const value =
          array[i][key] !== null && array[i][key] !== undefined
            ? array[i][key]
            : "";

        if (line !== "") line += ";";

        line += value;
      }

      str += line + "\r\n";
    }

    let downloadLink = document.createElement("a");
    downloadLink.href =
      "data:text/csv;charset=utf-8," + encodeURIComponent(str);
    downloadLink.download = "consultazione_UDA.csv";

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }; //onDownload

  //--- ---

  render() {
    let { loading, payload, searched, whereObj } = this.state;

    //--- ---

    return (
      <>
        <Section className="m-0 p-0">
          <Title>Consultazione Prova scritta</Title>
        </Section>

        <Section className="my-4 p-0">
          <div className="form-row m-0 p-0">
            <div className="col-md-4">
              <MInput
                {...this.state.searchFields.find((f) => f.id === "finder")}
                className="mb-0"
                onChange={(elm, value) =>
                  this.handleFieldChange("finder", value)
                }
              />
            </div>

            <div className="col-md-3">
              <MSelect {...this.state.contextSelectField} />
            </div>

            <div className="col-md-2">
              <MInput
                {...this.state.searchFields.find((f) => f.id === "aaYear")}
                className="mb-0"
                onChange={(elm, value) =>
                  this.handleFieldChange("aaYear", value)
                }
              />
            </div>

            <div className="col-md-1">
              <Button
                color="primary bg-dark"
                className="d-block"
                onClick={() => this.handleSearch()}
              >
                CERCA
              </Button>
            </div>
            {this.state.payload.length > 0 && (
              <div className="col-md-1 text-left">
                <Button
                  color="primary bg-dark"
                  className="d-block"
                  onClick={() => {
                    this.onDownload();
                  }}
                >
                  DOWNLOAD
                </Button>
              </div>
            )}
          </div>
        </Section>

        {loading ? (
          <MnemoLoading></MnemoLoading>
        ) : (
          <>
            <Container>
              <MTable
                key={this.state.rndKey}
                tableData={this.state.payload}
                tableConfig={
                  whereObj.contextFilter === REVISOR_CONTEXTS.TFAINDIRE
                    ? this.tableConfig_TFAIndire
                    : this.tableConfig
                }
              />
            </Container>

            {payload.length === 0 && searched && (
              <BoxDanger key="nrp-1" className="my-3">
                <div className="small text-info">Non sono presenti dati.</div>
              </BoxDanger>
            )}
          </>
        )}
      </>
    );
  }
}

export default withRouter(ViewerUDA);
